export default "__VITE_ASSET__8390fc25__"